import theme from '@ifca-root/react-component/src/assets/theme'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core'
import React, { ChangeEvent, useMemo, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { AcctPermission, ApprovalStatus } from 'generated/graphql'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { formatDate } from 'helpers/StringNumberFunction/FormatDate'
import { AccountFooter } from 'components/Footer/AccountFooter'
import { AssetsCountDetailContent } from '../AssetsCountDetail/AssetsCountDetailContent'
import { AssetsCountDetailitemContent } from '../AssetsCountDetail/AssetsCountDetaiItemContent'
import { CardExpansionHeader } from 'components/CardExpansion/CardExpansionHeader'

interface AssetListProps {
  filteredList: any[]
  listLoading: boolean
  listStatus: string
  userList: any[]
  fetchMore: Function
  setOriginalListing: Function
}

export const AssetsCountPostingList: React.FC<AssetListProps> = ({
  filteredList,
  listLoading,
  listStatus,
  userList,
  fetchMore,
  setOriginalListing,
}) => {
  const { handlePermDisabled } = usePermissionChecker()
  const [postIDs, setPostIDs] = useState<Set<string>>(new Set())
  const [selectAll, setSelectAll] = useState(false)

  // Memoized filtered and sorted list
  const sortedList = useMemo(() => {
    return filteredList?.sort(
      (a, b) =>
        Object.values(ApprovalStatus).indexOf(a?.ApprovalStatus) -
        Object.values(ApprovalStatus).indexOf(b?.ApprovalStatus)
    )
  }, [filteredList])

  const handleCheckBoxChange = (
    e: ChangeEvent<HTMLInputElement>,
    AuditAdjustmentID: string
  ) => {
    const newSet = new Set(postIDs)
    if (e.target.checked) {
      newSet.add(AuditAdjustmentID)
    } else {
      newSet.delete(AuditAdjustmentID)
      setSelectAll(false)
    }
    setPostIDs(newSet)
  }

  const handleSelectAll = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setSelectAll(isChecked)

    const newSet = new Set(
      isChecked ? checkedFilteredList.map(el => el.AuditAdjustmentID) : []
    )
    setPostIDs(newSet)
  }

  const checkedFilteredList =
    filteredList && filteredList.length > 0 ? filteredList : []

  const onSubmitApprove = () => {
    console.log('Approving selected records:', Array.from(postIDs))
    // Implement approval logic here
  }

  return (
    <>
      {listLoading && <Loading />}

      <ContentWrapper overflow>
        {listStatus === 'SUBMIT' && checkedFilteredList?.length !== 0 ? (
          <span className="mdDesc flex-space" style={{ paddingLeft: '7px' }}>
            <Checkbox
              value=""
              color="primary"
              onChange={handleSelectAll}
              style={{ marginLeft: '-5px', marginTop: '5px' }}
              checked={
                postIDs?.size > 0 && postIDs.size === checkedFilteredList.length
              }
            />
            <span style={{ marginLeft: '9px' }}>Select All</span>
          </span>
        ) : null}

        <List className="core-list">
          {checkedFilteredList === undefined ||
          checkedFilteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={checkedFilteredList.length}
              next={fetchMore}
              hasMore={true}
              style={{ padding: '8px 6px' }}
              loader={
                listLoading && (
                  <div style={{ textAlign: 'center' }}>
                    <CircularProgress />
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {checkedFilteredList.map((el, index) => (
                <CardExpansion
                  key={index}
                  summary={
                    <ListItem>
                      {listStatus === 'SUBMIT' && (
                        <FormControl
                          component="fieldset"
                          style={{ marginLeft: '10px', marginRight: '-5px' }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                value={el.AuditAdjustmentID}
                                onChange={e =>
                                  handleCheckBoxChange(e, el.AuditAdjustmentID)
                                }
                                checked={postIDs.has(el.AuditAdjustmentID)}
                                color="primary"
                                disabled={handlePermDisabled({
                                  permEnum:
                                    AcctPermission.GeneralLedgerAuditAdjustmentApproveReject,
                                })}
                              />
                            }
                            label=""
                          />
                        </FormControl>
                      )}
                      <ListItemText
                        primary={
                          <>
                            <span className="xsTitle flex-space">
                              {el?.Name}
                            </span>
                            <span className="Flex-space label">
                              {formatDate(el?.Date)}
                            </span>
                          </>
                        }
                        secondary={
                          <>
                            <div className="desc flex-space">
                              <div>{el?.Description}</div>
                            </div>
                            <span className="desc">
                              <span style={{ color: 'orange' }}>
                                {el?.Counts}
                              </span>{' '}
                              item counts
                            </span>
                          </>
                        }
                      />
                    </ListItem>
                  }
                >
                  <AssetsCountDetailContent
                    listEl={el}
                    documentListing={el?.Attachment}
                    listStatus={'SUBMIT'}
                    userList={userList}
                    mode={'expansion'}
                  />
                  <CardExpansionHeader title="Stock Item (3)" />
                  <AssetsCountDetailitemContent
                    listItem={el?.AssetsCountDetailitem}
                  />
                </CardExpansion>
              ))}
            </InfiniteScroll>
          )}
        </List>
        <div style={{ marginBottom: '100px' }}></div>
      </ContentWrapper>

      {listStatus === 'SUBMIT' && (
        <AccountFooter
          options={[
            {
              name: 'Reject',
              onClick: () => console.log('Open reject dialog'),
              color: 'secondary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    permEnum:
                      AcctPermission.GeneralLedgerAuditAdjustmentApproveReject,
                  }),
              },
            },
            {
              name: 'Approve',
              onClick: onSubmitApprove,
              color: 'primary',
              props: {
                disabled:
                  postIDs.size === 0 ||
                  handlePermDisabled({
                    permEnum:
                      AcctPermission.GeneralLedgerAuditAdjustmentApproveReject,
                  }),
              },
            },
          ]}
        />
      )}
    </>
  )
}
